import React, { createContext, useContext, useState, useEffect } from 'react';
import { requirementsAPI, adminRequirementsAPI, authHelpers } from '../services/api';
import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

const CurrencyContext = createContext();

export const useCurrency = () => {
    const context = useContext(CurrencyContext);
    if (!context) {
        return {
            currencySymbol: '₹',
            formatAmount: (amount) => `₹${parseFloat(amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
        };
    }
    return context;
};

export const CurrencyProvider = ({ children }) => {
    const [currencySymbol, setCurrencySymbol] = useState('₹');
    const location = useLocation();
    const { isAuthenticated } = useAuth();
    const isAdminPath = location.pathname.startsWith('/admin-users');

    const fetchCurrencySetting = async () => {
        try {
            // Only fetch if authenticated for non-admin paths, or if it's an admin path
            // (admin-requirements might have different auth rules, but generally we want a token)
            if (!isAuthenticated && !isAdminPath) return;

            if (isAdminPath) {
                const response = await adminRequirementsAPI.get();
                if (response.data.success && response.data.data.doller_currency) {
                    setCurrencySymbol('$');
                } else {
                    setCurrencySymbol('₹');
                }
            } else {
                const response = await requirementsAPI.getRequirements();
                if (response.data.success && response.data.data.Doller_Currency) {
                    setCurrencySymbol('$');
                } else {
                    setCurrencySymbol('₹');
                }
            }
        } catch (error) {
            setCurrencySymbol('₹');
        }
    };

    useEffect(() => {
        fetchCurrencySetting();
    }, [isAdminPath, isAuthenticated]);

    const refreshCurrency = async () => {
        await fetchCurrencySetting();
    };

    const formatAmount = (amount) => {
        const locale = currencySymbol === '$' ? 'en-US' : 'en-IN';
        return `${currencySymbol}${parseFloat(amount || 0).toLocaleString(locale, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    };

    return (
        <CurrencyContext.Provider value={{ currencySymbol, refreshCurrency, formatAmount }}>
            {children}
        </CurrencyContext.Provider>
    );
};

export default CurrencyContext;